import { useMutation } from 'react-query';
import * as api from '../../services/api';
import useToaster from '../useToaster';
import useAccount from './useAccount';

const useSpecificPayroll = (refetchPayroll) => {
  const { accountId } = useAccount();
  const { addResponseError } = useToaster();

  const updateWage = useMutation(({ wageId, ...wage }) => api.updateWage({ accountId, wageId, wage }), {
    onSuccess: (data, { timesheetId, employeeId }) => refetchPayroll({ timesheetId, employeeId }),
    onError: (error) => addResponseError(error)
  });

  const updateField = useMutation(
    ({ jobId, employeeSlotId, payrollFieldId, value, valueKey = 'value' }) =>
      employeeSlotId
        ? api.updateSlotPayrollField({ accountId, employeeSlotId, payrollFieldId, valueKey, value })
        : api.updateJobPayrollField({ accountId, jobId, payrollFieldId, value }),
    {
      onSuccess: (data, { timesheetId, employeeId }) => refetchPayroll({ timesheetId, employeeId }),
      onError: (error) => addResponseError(error)
    }
  );

  const updateFields = useMutation(
    ({ employeeSlotId, values }) => api.updateSlotPayrollFields({ accountId, employeeSlotId, values }),
    {
      onError: (error) => addResponseError(error)
    }
  );

  return { updateWage, updateField, updateFields };
};

export default useSpecificPayroll;
